<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_661')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_662')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.src" :placeholder="$t('scope.text_663')" @change="srcChange">
            <a-select-option v-for="item in currencyTypes" :value="item.value" :key="item.key" :disabled="item.value === currentDest">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('scope.text_664')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.dest"  :placeholder="$t('scope.text_665')" @change="destChange">
            <a-select-option v-for="item in currencyTypes" :value="item.value" :key="item.key" :disabled="item.value === currentSrc">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('scope.text_666')" v-bind="formItemLayout">
          <a-input-number v-decorator="decorators.rate" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_310')" v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.date"
            :placeholder="$t('scope.text_667')"
            format="YYYY-MM-DD"
            :disabled-date="disabledDate" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillExchangeRateCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      currencyTypes: [
        { key: 'CNY', value: 'CNY' },
        { key: 'USD', value: 'USD' },
        { key: 'HKD', value: 'HKD' },
        { key: 'EUR', value: 'EUR' },
        { key: 'GBP', value: 'GBP' },
        { key: 'JPY', value: 'JPY' },
      ],
      currentSrc: '',
      currentDest: '',
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        src: [
          'src',
          {
            rules: [
              { required: true, message: this.$t('scope.text_663') },
            ],
          },
        ],
        dest: [
          'dest',
          {
            rules: [
              { required: true, message: this.$t('scope.text_665') },
            ],
          },
        ],
        rate: [
          'rate',
          {
            rules: [
              { required: true, message: this.$t('scope.text_668') },
            ],
          },
        ],
        date: [
          'date',
          {
            rules: [
              { required: true, message: this.$t('scope.text_667') },
            ],
          },
        ],
      },
    }
  },
  methods: {
    srcChange (value) {
      this.currentSrc = value
    },
    destChange (value) {
      this.currentDest = value
    },
    disabledDate (current) {
      return current && current > this.$moment().endOf('day')
    },
    doSend (data) {
      return new this.$Manager('/billing_exchange_rates').create({
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        values.date = this.$moment(values.date).format('YYYYMMDD')
        await this.doSend(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
